<template>
  <div class="aboutus">
    <basepanel>
      <div class="outer-box">
        <!-- horizontal-box 手机端加上该样式 -->
        <div :class="{ 'inner-box': true, 'horizontal-box': phoneshow }">
          <div class="all-modules">
            <div class="contactus">
              <div class="content">
                <div class="cont-left" id="allmap">
                  <baidu-map id="allmap" :center="markerPoint" :zoom="15">
                    <bm-navigation
                      anchor="BMAP_ANCHOR_TOP_RIGHT"
                    ></bm-navigation>
                    <bm-marker
                      :icon="{
                        url: require('../../assets/images/aboutus/local.png'),
                        size: { width: 50, height: 50 },
                      }"
                      :position="markerPoint"
                      @click="selectMap"
                    >
                      <bm-info-window
                        :offset="{ width: 10, height: -20 }"
                        v-if="show"
                        :show="isShowInfo"
                        @close="infoWindowClose"
                        @open="infoWindowOpen"
                      >
                        <div class="mapInfo">
                          <div>重庆尚优科技有限公司</div>
                          <span
                            >重庆市两江新区杨柳路3号重科智谷A座27F</span
                          >
                          <div></div>
                        </div>
                      </bm-info-window>
                    </bm-marker>
                    <!-- <bm-marker :position="markerPoint"  @click="selectMap"></bm-marker> -->
                    <bm-control
                      class="infoBtn"
                      anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                    >
                      <el-button
                        :size="btnSize"
                        @click="showinfo"
                        v-if="show"
                        :disabled="isShowInfo"
                        >显示位置信息</el-button
                      >
                      <el-button :size="btnSize" @click="showinfo" v-else
                        >回到原来位置</el-button
                      >
                    </bm-control>
                  </baidu-map>
                </div>
                <div class="cont-right">
                  <div class="left">
                    <p class="company">重庆尚优科技有限公司</p>
                    <!-- <p>
                      <i class="el-icon-user"></i>
                      联系人：{{ this.selectOne.people }}
                    </p> -->
                    <p>
                      <i class="el-icon-phone-outline"></i>
                      联系电话：{{ this.selectOne.number }}
                    </p>
                    <p>
                      <i class="el-icon-message"></i>
                      联系邮箱：{{ this.selectOne.email }}
                    </p>
                    <p>
                      <i class="el-icon-location-outline"></i>
                      <!-- {{ this.selectOne.Adress }} -->
                      地址：重庆市两江新区杨柳路3号重科智谷A座27F
                    </p>
                  </div>
                  <div class="right">
                    <img :src="selectOne.defineUrl" alt />
                    <!-- <div>   <img :src="selectOne.defineUrl" alt="" /></div> -->
                    <div>关注我们，了解尚优科技</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </basepanel>
    <el-drawer
      title="请选择已安装的APP"
      :visible.sync="mapDrawer"
      direction="btt"
      :before-close="mapClose"
    >
      <ul>
        <li
          class="mapName"
          v-for="(item, i) in mapActions"
          :key="i"
          @click="goMap(item)"
        >
          {{ item.name }}
        </li>
      </ul>
    </el-drawer>
  </div>
</template>

<script>
import basepanel from "../../components/BasePanel";
import { listNextWithFilter, view } from "../../api/index";
export default {
  name: "contactus",
  components: { basepanel },
  data() {
    return {
      // 核心技术
      coreLists: [],
      // 加入我们
      selectIndex: 0, //默认选中的索引
      mapDrawer: false,
      mapActions: [
        { id: 1, name: "百度地图" },
        { id: 2, name: "高德地图" },
      ],
      selectOne: {},
      markerPoint: { lng: 106.505257, lat:29.619077 },
      // markerPoint: { lng: 106.51584, lat: 29.620552 },
      //  map: [this.$map.newscategoryId, this.$map.news2categoryId],
      screenWidth: document.body.clientWidth,
      isShowInfo: true,
      btnSize: "mini",
      show: true,
    };
  },
  computed: {
    phoneshow: function () {
      return this.screenWidth < 768 ? true : false;
    },
  },
  methods: {
    infoWindowClose() {
      this.isShowInfo = false;
    },
    infoWindowOpen() {
      this.isShowInfo = true;
    },
    //显示位置信息
    showinfo() {
      let { lng, lat } = this.markerPoint;
      this.markerPoint = {
        lng: 0,
        lat: 0,
      };
      // 异步执行, 是为了视图能对数据变化做出反应, 否则无法实现效果
      setTimeout(() => {
        this.markerPoint = {
          lng,
          lat,
        };
      }, 10);
      this.isShowInfo = true;
    },
    mapClose() {
      this.mapDrawer = false;
    },
    goMap(item) {
      let longitude = this.markerPoint.lng,
        latitude = this.markerPoint.lat;
      let name = "重庆尚优科技有限公司";
      let url = "";
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
      if (isAndroid) {
        if (item.id == 1) {
          url = `http://api.map.baidu.com/marker?location=${latitude},${longitude}&title=${name}&content=${name}&output=html&src=andr.baidu.openAPIdemo`;
          // url = `bdapp://api.map.baidu.com/marker?location=${latitude},${longitude}&title=${name}&content=${name}&output=html&src=andr.baidu.openAPIdemo`;
        } else {
          url = `//uri.amap.com/marker?poiid=B0FFI9JH6V&src=mypage&callnative=0`;
        }
        if (url != "") {
          window.location.href = url;
        }
      } else if (isiOS) {
        if (item.id == 1) {
          url = `http://api.map.baidu.com/marker?location=${latitude},${longitude}&title=${name}&content=${name}&output=html&src=ios.baidu.openAPIdemo`;
        } else {
          url = `//uri.amap.com/marker?poiid=B0FFI9JH6V&src=mypage&callnative=0`; //callnative=0不唤起app，callnative唤起app
        }
        if (url != "") {
          window.location.href = url;
        }
      }
    },
    selectMap() {
      let web = window.innerWidth;
      if (web > 1200) {
        this.mapDrawer = false;
      } else {
        this.mapDrawer = true;
      }
    },
    handleClick(tab) {
      this.activeIndex = (parseInt(tab.index) + 1).toString();
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.activeIndex = key;
    },
    async getCoreLists() {
      let send = {
        url: {
          page: 1,
          size: 30,
        },
        data: {
          categoryIdList: [this.$map.corecategoryId],
          needData: true,
        },
      };
      let res = await listNextWithFilter(send);
      if (res.type == "success") {
        let lists = res.data;
        lists.map((val) => {
          this.$set(val, "defineUrl", this.$srcHandle(val.data.imageclipper));
        });
        this.coreLists = lists;
        // new WOW().init();
      } else {
        console.log(res.msg);
      }
    },

    selectJob(index) {
      this.selectIndex = index;
      if (!this.content[index]) {
        this.getJobsDetail(this.jobList[index].id);
      } else {
        this.select = this.content[this.selectIndex];
      }
    },
    async getJobs() {
      let send = {
        url: {
          page: 1,
          size: 20,
        },
        data: {
          categoryIdList: [this.$map.recruitcategoryId],
        },
      };
      let res = await listNextWithFilter(send);
      if (res.type == "success") {
        this.jobList = res.data;
        this.getJobsDetail(this.jobList[0].id);
      } else {
        console.log(res.msg);
      }
    },
    // 获取职位详情
    async getJobsDetail(id) {
      let send = {
        url: {
          id,
        },
      };
      let res = await view(send);
      if (res.type == "success") {
        let data = res.data.data;
        this.select = data;
      } else {
        console.log(res.msg);
      }
    },

    async getData(id) {
      let send = {
        url: {
          id,
        },
      };
      let res = await view(send);
      if (res.type == "success") {
        let data = res.data.data;
        this.$set(data, "defineUrl", this.$srcHandle(data.imageclipper));
        // this.contact[this.currIndex] = data;
        this.selectOne = data;
      } else {
        console.log(res.msg);
      }
    },
  },
  watch: {
    screenWidth(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          this.timer = false;
        }, 400);
      }
    },
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
    if (this.screenWidth < 400) {
      this.show = false;
    }
    this.getCoreLists();
    this.getJobs();
    // this.getData(this.Ids[this.currIndex]);
    this.getData(this.$map.cq);
  },
};
</script>

<style scoped lang="less">
.aboutus {
  .mapName {
    text-align: center;
    margin: 25px 0;
  }
  .inner-box {
    display: flex;
    justify-content: space-between;
    .horizontal-tabs {
      display: none;
    }
    .all-modules {
      width: 100%;
      padding-left: 6%;
      .core {
        .sec {
          display: inline-block;
          vertical-align: top;
          // cursor: pointer;
          margin-right: 2%;
          text-decoration: none;
          color: #000;
          // margin-bottom: 20px;
          // background-color: #fff;
          // &:hover {
          //   box-shadow: 0 0 16px #0e6cb6;
          //   transition: all 0.3s ease;
          // }
          .top {
            width: 100%;
          }
          .title {
            // overflow: hidden;
            // text-overflow: ellipsis;
            // white-space: nowrap;
            text-align: center;
          }
        }
        .special {
          margin-right: 0;
        }
        .hint {
          text-align: right;
          margin-top: 6px;
          letter-spacing: 1px;
          @font-face {
            font-family: "iconfont"; /* Project id  */
            src: url("../../assets/iconfont.ttf?t=1620782934324")
              format("truetype");
          }

          .iconfont {
            font-family: "iconfont" !important;
            font-size: 16px;
            font-style: normal;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }

          .icon-weibiaoti-:before {
            content: "\e613";
          }
        }
      }
      .recruitment {
        ul {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          li {
            text-align: center;
            // border: 1px solid #010439;
            cursor: pointer;
            // padding: 16px;
            background-color: #e3eaf0;
            border-radius: 6px;
            color: #333333;
            // margin-right: 20px;
            // margin-bottom: 20px;
          }
          .active {
            color: #ffffff;
            background-color: #0e6cb6;
          }
        }
      }
      .contactus {
        .content {
          .cont-left {
            width: 100%;
            #allmap {
              .infoBtn {
                margin: 0 10px 10px 0;
                box-shadow: 10px 5px 10px #00000057;
              }

              // height: 546px;
              /* 去除百度地图版权那行字 和 百度logo */
              /deep/.BMap_cpyCtrl {
                display: none !important;
              }
              /deep/.anchorBL {
                display: none !important;
              }
              .mapInfo {
                div {
                  text-align: center;
                  margin-bottom: 10px;
                  font-weight: bold;
                  font-size: 17px;
                }
                span {
                  display: inline-block;
                  width: 100%;
                  text-align: center;
                  color: #666;
                  font-size: 13px;
                }
              }
            }
          }
          .cont-right {
            padding-top: 10px;
            margin-top: 40px;
            // width: 100%;
            // display: flex;
            // justify-content: space-between;
            .left {
              float: left;
            }
            .right {
              float: right;
              text-align: center;
            }
            .company {
              color: #0060a3;
              font-size: 30px;
            }
            p {
              color: #333333;
              line-height: 60px;
              i {
                margin-right: 10px;
              }
            }
            img {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .horizontal-box {
    flex-direction: column;
    .horizontal-tabs {
      display: block;
      /deep/.el-tabs__header {
        margin-bottom: 20px;
        .el-tabs__nav {
          width: 100%;
          .el-tabs__item {
            width: 33%;
            text-align: center;
            padding: 0;
            color: #666666;
            &:hover {
              color: #0e6cb6;
            }
          }
          .el-tabs__item.is-active {
            color: #0e6cb6;
          }
          .el-tabs__active-bar {
            width: 20% !important;
            left: 6%;
            background-color: #0e6cb6;
          }
        }
      }
    }
    .el-menu-vertical {
      display: none;
    }
    .all-modules {
      padding-left: 0;
    }
  }
}

@media screen and (min-width: 1200px) {
  .el-menu-vertical {
    .el-menu-item {
      font-size: 24px;
      line-height: 33px;
      margin-bottom: 52px;
      .side {
        height: 33px;
        width: 6px;
        margin-right: 20px;
      }
    }
  }
  .core {
    .sec {
      width: 32%;
      margin-bottom: 12px;
    }
    .title {
      font-size: 22px;
      // min-height: 100px;
      color: #333;
      line-height: 52px;
      letter-spacing: 3px;
    }
    .hint {
      font-size: 16px;
    }
  }
  .recruitment {
    ul {
      li {
        width: 200px;
        padding: 16px;
        font-size: 20px;
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }
    .info {
      padding: 12px;
      h2 {
        line-height: 40px;
        font-size: 22px;
        letter-spacing: 3px;
        margin-top: 12px;
      }
      div {
        line-height: 34px;
        font-size: 18px;
        letter-spacing: 3px;
      }
    }
  }
  .contactus {
    .cont-left {
      width: 100%;
      #allmap {
        height: 546px;
      }
    }
    .cont-right {
      width: 100%;
      .left {
        float: left;
      }

      .right {
        width: 20%; 
        div {
          margin-top: 10px;
          text-algin: center;
        }
        img {
          width: 100%;
        }
       
      }
      p {
        line-height: 35px;
        font-size: 20px;
        letter-spacing: 2px;
      }
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  //ipad pro
  .el-menu-vertical {
    .el-menu-item {
      font-size: 20px;
      line-height: 25px;
      margin-bottom: 46px;
      .side {
        height: 30px;
        width: 6px;
        margin-right: 20px;
      }
    }
  }
  .core {
    .sec {
      width: 32%;
      margin-bottom: 12px;
    }
    .title {
      font-size: 18px;
      // min-height: 90px;
      color: #333;
      line-height: 32px;
      letter-spacing: 2px;
    }
    .hint {
      font-size: 16px;
    }
  }
  .recruitment {
    ul {
      li {
        width: 190px;
        padding: 16px;
        font-size: 16px;
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }
    .info {
      padding: 12px;
      h2 {
        line-height: 40px;
        font-size: 18px;
        letter-spacing: 2px;
        margin-top: 12px;
      }
      div {
        line-height: 30px;
        font-size: 16px;
        letter-spacing: 2px;
      }
    }
  }
  .contactus {
    .cont-left {
      width: 100%;
      #allmap {
        height: 420px;
      }
    }
    .cont-right {
      width: 100%;
      .right {
        width: 30%;
        float: left !important;
        div {
          margin-top: 10px;
        }
      }
      p {
        line-height: 26px;
        font-size: 16px;
        letter-spacing: 2px;
      }
    }
  }
}
@media screen and (min-width: 414px) and (max-width: 768px) {
  //ipad
  /deep/ .el-tabs__nav {
    line-height: 40px !important;
    .el-tabs__item {
      font-size: 18px;
    }
  }
  .el-menu-vertical {
    .el-menu-item {
      font-size: 18px;
      line-height: 30px;
      margin-bottom: 46px;
      .side {
        height: 30px;
        width: 6px;
        margin-right: 16px;
      }
    }
  }
  .core {
    .sec {
      width: 48%;
      margin-bottom: 6px;
    }
    .title {
      font-size: 16px;
      // min-height: 56px;
      color: #333;
      line-height: 26px;
      letter-spacing: 2px;
    }
    .hint {
      font-size: 14px;
    }
  }
  .recruitment {
    ul {
      li {
        // width: 190px;
        padding: 8px;
        font-size: 14px;
        margin-right: 6px;
        margin-bottom: 10px;
      }
    }
    .info {
      padding: 12px;
      h2 {
        line-height: 40px;
        font-size: 16px;
        letter-spacing: 2px;
        margin-top: 12px;
      }
      div {
        line-height: 24px;
        font-size: 14px;
        letter-spacing: 2px;
      }
    }
  }
  .contactus {
    .cont-left {
      width: 100%;
      #allmap {
        height: 300px;
        margin-bottom: 15px;
      }
    }
    .cont-right {
      width: 100%;
      .right {
        width: 33%;
        float: left !important;
      }
      p {
        line-height: 25px;
        font-size: 16px;
        letter-spacing: 2px;
      }
    }
  }
}
@media screen and (max-width: 414px) {
  .mapInfo {
    div {
      font-size: 14px !important;
    }
  }
  //phone
  /deep/ .el-tabs__nav {
    line-height: 30px !important;
    .el-tabs__item {
      font-size: 16px;
    }
  }
  .el-menu-vertical {
    width: 22%;
    .el-menu-item {
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 30px;
      .side {
        height: 18px;
        width: 4px;
        margin-right: 8px;
      }
    }
  }
  .all-modules {
    width: 72%;
  }
  .core {
    .sec {
      width: 48%;
      margin-bottom: 6px;
    }
    .title {
      font-size: 12px;
      // min-height: 40px;
      color: #333;
      line-height: 18px;
      letter-spacing: 2px;
    }
    .hint {
      font-size: 12px;
    }
  }
  .recruitment {
    ul {
      li {
        // width: 190px;
        padding: 6px;
        font-size: 12px;
        margin-right: 6px;
        margin-bottom: 10px;
      }
    }
    .info {
      padding: 12px;
      h2 {
        line-height: 30px;
        font-size: 14px;
        letter-spacing: 1px;
        margin-top: 8px;
      }
      div {
        line-height: 20px;
        font-size: 12px;
        letter-spacing: 1spx;
      }
    }
  }
  .contactus {
    .cont-left {
      width: 100%;
      #allmap {
        height: 200px;
        margin-bottom: 15px;
      }
    }
    .cont-right {
      margin-bottom: 14vh;
      img {
        margin-top: 0;
      }
      .left {
        width: 100%;
      }
      .right {
        width: 40%;
        float: left !important;
        margin-top: 10px;
        margin-bottom: 10px;
        div {
          font-size: 10px;
          margin-top: 10px;
        }
      }

      p:first-child {
        font-size: 18px !important;
      }
      p {
        line-height: 32px !important;
        font-size: 14px;
        letter-spacing: 1px;
      }
    }
  }
}
</style>
